<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <loading-spinner v-if="isLoading"></loading-spinner>

                <v-card v-else>
                    <card-header :title="$t('title.announcement')"></card-header>
                    <v-card-text v-if="!isLoading" class="pa-5">
                        <div>
                            <h4 class="font-weight-bold accent--text">{{ post.title }}</h4>
                            <hr class="mt-3 mb-3">

                            <div>
                                <div class="d-flex text-left">
                                    <label class="font-weight-bold mr-2">{{ $t('label.post_writer') }}</label>
                                    <p>
                                        {{ post.member.name }}
                                    </p>
                                </div>
                                <div class="d-flex text-left">
                                    <label class="font-weight-bold mr-2">{{ $t('label.post_created_at') }}</label>
                                    <p>
                                        {{ post.created_at }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="mt-3 mb-3">
                            <div>
                                <div v-html="post.content"></div>
                            </div>
                        </div>
                        <hr class="mt-3 mb-3">
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <custom-button @click="handleClose" color="black" :label="$t('button.close')" size="lg"
                                gradient rounded></custom-button>
                        </v-card-actions>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import CardHeader from '@/components/cards/CardHeader.vue';
import LoadingSpinner from '@/components/common/Spinners/LoadingSpinner.vue';
import CustomButton from '@/components/common/buttons/CustomButton.vue';

import { boardApi } from '@/api/api';

export default {
    name: "show-announcement",
    components: {
        CardHeader,
        LoadingSpinner,
        CustomButton,
    },
    props: {
        idx: {
            type: [String, Number],
            required: true,
        }
    },
    data() {
        return {
            isLoading: false,
            post: {
                title: null,
                content: null,
                created_at: null,
                file_path: null,
                down_file_name: null,
                member: {
                    name: null,
                },
            },
        }
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },
        async handleClose() {
            this.goBack();
        },
        async fetchPost() {
            const post = {
                idx: this.idx,
            }
            try {
                this.isLoading = true;
                const response = await boardApi.getPost(post);

                if (response && response.status === 200) {
                    this.post = response.data.response;
                    return true;
                }

                return false;
            }
            catch {
                alert("요청을 처리할 수 없습니다. 잠시 후 다시 시도해주세요.");
                this.goBack();
                return false;
            } finally {
                this.isLoading = false;
            }
        }
    },
    mounted() {
        this.fetchPost();
    },
}
</script>

<style lang="scss" scoped>
hr {
    border: 1px solid rgba(233, 233, 233, 0.5);
}
</style>